import { type SyntheticEvent } from 'react';
import { X } from 'lucide-react';
import { IconButton } from '@zillow/constellation-10';
import { cx } from '@/styled-system/css';
import { LucideIcon } from '@/src/components/LucideIcon';
import { cardArrow, cardContainer, cardShell, closeButton } from './mapInfoCardShell.styles';

type MapInfoCardShellProps = {
  children: React.ReactNode;
  closeButtonClassName?: string;
  closeTestId?: string;
  containerClassName?: string;
  closeLabel?: string;
  onClose?: () => void;
  testId?: string;
};

const stopMapEventPropagation = (event: SyntheticEvent<HTMLDivElement>) => {
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation?.();
};

export const MapInfoCardShell = ({
  children,
  closeButtonClassName,
  closeTestId,
  closeLabel,
  containerClassName,
  onClose,
  testId,
}: MapInfoCardShellProps) => (
  <div
    className={cardShell}
    data-testid={testId}
    onClick={stopMapEventPropagation}
    onContextMenu={stopMapEventPropagation}
    onDoubleClick={stopMapEventPropagation}
    onMouseDown={stopMapEventPropagation}
    onMouseMove={stopMapEventPropagation}
    onMouseUp={stopMapEventPropagation}
    onPointerDown={stopMapEventPropagation}
    onPointerMove={stopMapEventPropagation}
    onPointerUp={stopMapEventPropagation}
    onTouchMove={stopMapEventPropagation}
    onTouchStart={stopMapEventPropagation}
    onWheel={stopMapEventPropagation}
  >
    <div className={cx(cardContainer, containerClassName)}>
      {children}
      {onClose && closeLabel && (
        <IconButton
          title={closeLabel}
          shape="circle"
          tone="neutral-fixed"
          emphasis="filled"
          onImpact
          size="xs"
          className={cx(closeButton, closeButtonClassName)}
          onClick={onClose}
          data-testid={closeTestId}
        >
          <LucideIcon icon={X} size="sm" />
        </IconButton>
      )}
    </div>
    <div className={cardArrow} data-testid={`${testId ?? 'map-info-card'}-arrow`} aria-hidden="true" />
  </div>
);
